import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {generatePath, useNavigate, useParams} from "react-router-dom";
import {selectStore} from "../../../../store/selector";
import React, {useCallback, useEffect, useMemo, useRef, useState} from "react";
import {
  Badge,
  Card,
  Col,
  Input,
  Modal,
  Popconfirm,
  Popover,
  Row,
  Select,
  Table,
} from "antd";
import {Excel} from "antd-table-saveas-excel";
import {InnerTabs, MyButton, MyText} from "../../../../components";
import {
  addModuleWithoutDisc,
  changeRupInfo, createNewDisciplineRow, createNewRow, deleteRow, editRow,
  editSemesterSettingsAction,
  fetchCurrentRup, fetchDisciplines,
  fetchRup, fetchSemesterSettingsAction, getRupInfo, getRupInfoTypes, resetNewRupState, restoreStructure
} from "../../../../store/pages/rup/actions";
import {useDebounce} from "../../../../hooks";
import {COOKIE_KEY, ROUTE_PATH, RUP_BASE_TYPES} from "../../../../constants";
import {MoreOutlined} from "@ant-design/icons";
import cn from 'classnames'
import {StyledRupTable} from "./style";

export const TableRup = () => {
  const dispatch = useDispatch()
  const {i18n, t} = useTranslation('rup')
  const currentAppLanguage = i18n.language;
  const navigate = useNavigate();
  const {rupId} = useParams()

  const inputsRef = useRef([])

  inputsRef.current = []

  const settingInitialState = {
    rup_id: rupId,
    id: undefined,
    one: undefined,
    two: undefined,
    three: undefined,
    four: undefined,
    five: undefined,
    six: undefined,
    seven: undefined,
    eight: undefined,
  }

  const ROW_TYPE = {
    qualification: 'qualification',
    qualification_total: 'qualification_total',
    qualification_evelated: 'qualification_evelated',
    qualification_evelated_total: 'qualification_evelated_total',
    row_from_tup: 'row_from_tup',
    group: 'group',
    module: 'module',
    ro: 'ro',
    discipline: 'discipline',
    discipline_from_module: 'discipline_from_module',
    discipline_evelated: 'discipline_evelated',
    module_evelated: 'module_evelated',
  }

  const ROW_FIELD = {
    control_work: 'control_work',
    course_projects: 'course_projects',
    course_work: 'course_work',
    credit: 'credit',
    exam: 'exam',
    index: 'index',
    individual: 'individual',
    industrial_training: 'industrial_training',
    key: 'key',
    lab_pract_work: 'lab_pract_work',
    name: 'name',
    caption: 'caption',
    caption_current: 'caption_current',
    discipline_id: 'discipline_id',
    offset: 'offset',
    parent_id: 'parent_id',
    professional_training: 'professional_training',
    row_type: 'row_type',
    sem_1: 'sem_1',
    sem_2: 'sem_2',
    sem_3: 'sem_3',
    sem_4: 'sem_4',
    sem_5: 'sem_5',
    sem_6: 'sem_6',
    sem_7: 'sem_7',
    sem_8: 'sem_8',
    sort: 'sort',
    theoretical_training: 'theoretical_training',
    total_hours: 'total_hours',
    srs: 'srs',
    srsp: 'srsp',
  }

  const tableLegend = [
    {
      color: 'rgb(88, 86, 214)',
      label: t('table.qualification'),
    },
    {
      color: 'rgb(0, 156, 213)',
      label: t('groupModule'),
    },
    {
      color: 'rgb(255, 149, 0)',
      label: t('module'),
    },
    {
      color: 'rgb(175, 82, 222)',
      label: t('ro'),
    },
    {
      color: 'rgb(142, 142, 147)',
      label: t('disciplineModule'),
    },
    {
      color: '#520000',
      label: t('disciplineModuleUpperQualification'),
    },
    {
      color: 'rgb(255, 0, 255)',
      label: t('disciplineRo'),
    },
    {
      color: 'rgb(172, 142, 104)',
      label: t('advancedQualification'),
    },
    {
      color: 'rgb(102, 212, 207)',
      label: t('moduleAdvancedLevel'),
    },
    {
      color: 'rgb(52, 199, 89)',
      label: t('totalQualification'),
    },
    {
      color: 'rgb(255, 59, 48)',
      label: t('error.number'),
    },
    {
      color: 'rgb(255, 193, 7)',
      label: t('tupField'),
    }
  ]

  const {
    rup: {
      currentRup: currentRupState,
      currentRupTable: currentRupTableState,
      cloneRupTable: cloneRupTableState,
      rupsDisciplines: rupsDisciplinesState,
      semesterSettings: semesterSettingsState,
      rupTranslate: rupTranslateState,
      rupTypesTranslate: rupTypesTranslateState,
    }
  } = useSelector(selectStore)


  const [currentDataTable, setCurrentDataTable] = useState<any[]>([])

  const [isEditedRup, setIsEditedRup] = useState<boolean>(false)

  const [currentTab, setCurrentTab] = useState<string>('1')

  const [changedValue, setChangedValue] = useState<any[]>([])

  const [changedArray, setChangedArray] = useState<any[]>([])

  const [isSettingDisable, setIsSettingDisable] = useState<boolean>(true)

  const [settingState, setSettingState] = useState(settingInitialState)

  const [translateArr, setTranslateArr] = useState<any[]>([])

  const [translateRupItem, setTranslateRupItem] = useState<any>({})

  let settingArr: any[] = [
    {
      label: t('first'),
      func: 'one',
      value: settingState?.one,
      placeholder: t('week1sem')
    },
    {
      label: t('second'),
      func: 'two',
      value: settingState?.two,
      placeholder: t('week2sem')
    },
    {
      label: t('third'),
      func: 'three',
      value: settingState?.three,
      placeholder: t('week3sem')
    },
    {
      label: t('fourth'),
      func: 'four',
      value: settingState?.four,
      placeholder: t('week4sem')
    },
    {
      label: t('fifth'),
      func: 'five',
      value: settingState?.five,
      placeholder: t('week5sem')
    },
    {
      label: t('sixth'),
      func: 'six',
      value: settingState?.six,
      placeholder: t('week6sem')
    },
    {
      label: t('seventh'),
      func: 'seven',
      value: settingState?.seven,
      placeholder: t('week7sem')
    },
    {
      label: t('eighth'),
      func: 'eight',
      value: settingState?.eight,
      placeholder: t('week8sem')
    },
  ]

  const columnRupTranslate = [
    {
      title: 'Индекс',
      width: 50,
      render: (text: any, record: any, index: any) => (
        <span>{index + 1}</span>
      )
    },
    {
      title: `${t('rus')}`,
      dataIndex: 'caption_ru',
      render: (text: any, record: any, index: any) => (
        <Input defaultValue={text}
               onChange={(e: any) => changeTextTranslateHandler(record.id, 'caption_ru', e.target.value)}/>
      )
    },
    {
      title: `${t('kaz')}`,
      dataIndex: 'caption_kk',
      render: (text: any, record: any, index: any) => (
        <Input defaultValue={text}
               onChange={(e: any) => changeTextTranslateHandler(record.id, 'caption_kk', e.target.value)}/>
      )
    }
  ]


  useEffect(() => {
    if (semesterSettingsState.data) {
      setSettingState(semesterSettingsState.data)
    }
  }, [semesterSettingsState.data])

  useEffect(() => {
    if (rupTranslateState.data.length > 0 && rupTypesTranslateState.data.length > 0) {
      const nested = (arr: any) => arr.flatMap(({children, ...o}: any) => [o, ...nested(children)]);
      let filtered = nested(rupTranslateState.data).filter((item: any) => rupTypesTranslateState.data.includes(item.row_type)).filter((v: any, i: any, a: any) => a.findIndex((t: any) => (t.id === v.id)) === i)

      setTranslateArr(filtered)
    }
  }, [rupTranslateState.data])

  const handleChangeSemesterSetting = useCallback((key: any, value: any) => {
    setSettingState(prevState => ({
      ...prevState,
      [key]: value
    }))
  }, [])

  const handleSemesterSetting = useCallback(() => {
    let body = {
      ...settingState,
      rup_id: rupId
    }
    dispatch(editSemesterSettingsAction(body))
    setIsSettingDisable(true)
  }, [settingState])

  const changeTextTranslateHandler = useCallback((id: any, key: any, value: any) => {
    setTranslateArr(prevState => prevState.map((item: any, idx: any) => item.id === id ? {
      ...item,
      [key]: value
    } : item))

    let body = {id: id, [key]: value}
    setTranslateRupItem(body)
  }, [])

  const debouncedTranslateTerm = useDebounce(translateRupItem, 500);

  useEffect(() => {
    if (debouncedTranslateTerm.id) {
      dispatch(changeRupInfo(translateRupItem))
    }
  }, [debouncedTranslateTerm])

  useEffect(() => {
    dispatch(fetchCurrentRup(rupId))
    dispatch(fetchRup(rupId))
    dispatch(fetchSemesterSettingsAction(rupId))
    // @ts-ignore
    dispatch(fetchDisciplines())
    // @ts-ignore
    dispatch(getRupInfoTypes())
  }, [])

  useEffect(() => {
    if (currentRupTableState.data) {
      setCurrentDataTable(currentRupTableState.data)
    }
  }, [currentRupTableState.data])

  const columns: any = [
    {
      width: 50,
      className: 'action',
      fixed: 'left',
      render: (text: any, record: any, index: any) => columnActionRender(text, record, index)
    },
    // ...(process.env.REACT_APP_ENV === 'local' ?
    //   [
    //     {
    //       fixed: 'left',
    //       title: 'record.row_type',
    //       width: 200,
    //       render: (text: any, record: any, index: any) => {
    //         return <span>{record.row_type}</span>
    //       }
    //     },
    //   ] :
    //   []),
    {
      title: `${t('table.index')}`,
      dataIndex: ROW_FIELD.index,
      width: 60,
      className: 'index vertical',
      fixed: 'left',
      render: (text: any, record: any, index: any) => (
        <Input value={text}
               type="number"
               min={0}
               onKeyPress={(e) => handleKeyPress(e)}
               id={ROW_FIELD.index + index}
               onChange={(e) => handleChange(e.target.value, ROW_FIELD.index, record, index)}
               onPressEnter={(e) => handleEnter(e)}
               ref={handleSetRefs}
               disabled={!isEditedRup}
               onKeyDown={(e) => handleKeyDown(e)}
        />
      )
    },
    {
      title: `${t('table.moduleAndDisciplineName')}`,
      dataIndex: ROW_FIELD.name,
      width: 250,
      className: 'name',
      fixed: 'left',
      onCell: (record: any, rowIndex: any) => colSpanValue(record, 21),
      render: (text: any, record: any, index: any) => {
        return columnNameRender(record.caption_current ? record.caption_current : text, record, index, ROW_FIELD.name)
      }
    },
    {
      title: `${t('table.formControl')}`,
      className: 'formControl',
      children: [
        {
          __excelTitle__: 'Экзамен',
          title: t('table.exam'),
          dataIndex: ROW_FIELD.exam,
          className: 'exam vertical',
          width: 100,
          onCell: (record: any, rowIndex: any) => colSpanValue(record, 0),
          render: (text: any, record: any, index: any) => columnFormControlRender(text, record, index, ROW_FIELD.exam)
        }, {
          __excelTitle__: 'Зачёт',
          title: t('table.zachet'),
          dataIndex: ROW_FIELD.offset,
          className: 'zachet vertical',
          width: 100,
          onCell: (record: any, rowIndex: any) => colSpanValue(record, 0),
          render: (text: any, record: any, index: any) => columnFormControlRender(text, record, index, ROW_FIELD.offset)
        }, {
          __excelTitle__: 'Курсовой проект/работа',
          title: t('table.courseProj'),
          dataIndex: ROW_FIELD.course_work,
          className: 'courseProj vertical',
          width: 100,
          onCell: (record: any, rowIndex: any) => colSpanValue(record, 0),
          render: (text: any, record: any, index: any) => columnFormControlRender(text, record, index, ROW_FIELD.course_work)
        }, {
          __excelTitle__: 'Контрольная работа',
          title: t('table.courseWork'),
          dataIndex: ROW_FIELD.control_work,
          className: 'courseWork vertical',
          width: 100,
          onCell: (record: any, rowIndex: any) => colSpanValue(record, 0),
          render: (text: any, record: any, index: any) => columnFormControlRender(text, record, index, ROW_FIELD.control_work)
        },
      ],
    },
    {
      title: `${t('table.studyTime')}`,
      className: 'studyTime',
      children: [
        {
          __excelTitle__: 'Кредиты',
          title: t('table.credit'),
          dataIndex: ROW_FIELD.credit,
          width: 70,
          className: 'credit vertical',
          onCell: (record: any, rowIndex: any) => colSpanValue(record, 0),
          render: (text: any, record: any, index: any) => columnStudyTimeCreditRender(text, record, index, ROW_FIELD.credit)
        }, {
          __excelTitle__: 'Всего часов',
          title: t('table.totalHours'),
          dataIndex: ROW_FIELD.total_hours,
          width: 70,
          className: 'totalHours vertical',
          onCell: (record: any, rowIndex: any) => colSpanValue(record, 0),
          render: (text: any, record: any, index: any) => columnStudyTimeTotalHoursRender(text, record, index, ROW_FIELD.total_hours)
        }, {
          title: `${t('table.ofThem')}:`,
          children: [
            {
              __excelTitle__: 'Теоретическое обучение',
              title: t('table.theoreticalStudy'),
              dataIndex: ROW_FIELD.theoretical_training,
              className: 'theoreticalStudy vertical',
              width: 70,
              onCell: (record: any, rowIndex: any) => colSpanValue(record, 0),
              render: (text: any, record: any, index: any) => columnTotalHoursOfThemRender(text, record, index, ROW_FIELD.theoretical_training)
            }, {
              __excelTitle__: 'Лабораторно-практические работы',
              title: `${t('table.laboratoryAndPractical')} ${t('table.work')}`,
              dataIndex: ROW_FIELD.lab_pract_work,
              className: 'laboratoryAndPractical vertical',
              width: 70,
              onCell: (record: any, rowIndex: any) => colSpanValue(record, 0),
              render: (text: any, record: any, index: any) => columnTotalHoursOfThemRender(text, record, index, ROW_FIELD.lab_pract_work)
            }, {
              __excelTitle__: 'Курсовые проекты и работы',
              title: t('table.coursesProjAndWork'),
              dataIndex: ROW_FIELD.course_projects,
              className: 'coursesProjAndWork vertical',
              width: 70,
              onCell: (record: any, rowIndex: any) => colSpanValue(record, 0),
              render: (text: any, record: any, index: any) => columnTotalHoursOfThemRender(text, record, index, ROW_FIELD.course_projects)
            }, {
              __excelTitle__: t('table.srs'),
              title: t('table.srs'),
              dataIndex: ROW_FIELD.srs,
              className: 'srs vertical',
              width: 70,
              onCell: (record: any, rowIndex: any) => colSpanValue(record, 0),
              render: (text: any, record: any, index: any) => columnTotalHoursOfThemRender(text, record, index, ROW_FIELD.srs)
            }, {
              __excelTitle__: t('table.srsp'),
              title: t('table.srsp'),
              dataIndex: ROW_FIELD.srsp,
              className: 'srsp vertical',
              width: 70,
              onCell: (record: any, rowIndex: any) => colSpanValue(record, 0),
              render: (text: any, record: any, index: any) => columnTotalHoursOfThemRender(text, record, index, ROW_FIELD.srsp)
            },{
              __excelTitle__: 'Производственное обучение',
              title: t('table.industrialTraining'),
              dataIndex: ROW_FIELD.industrial_training,
              className: 'industrialTraining vertical',
              width: 70,
              onCell: (record: any, rowIndex: any) => colSpanValue(record, 0),
              render: (text: any, record: any, index: any) => columnTotalHoursOfThemRender(text, record, index, ROW_FIELD.industrial_training)
            }, {
              __excelTitle__: 'Профессиональная практика',
              title: t('table.professionalPractice'),
              dataIndex: ROW_FIELD.professional_training,
              className: 'professionalPractice vertical',
              width: 70,
              onCell: (record: any, rowIndex: any) => colSpanValue(record, 0),
              render: (text: any, record: any, index: any) => columnTotalHoursOfThemRender(text, record, index, ROW_FIELD.professional_training)
            }, {
              __excelTitle__: 'Индивидуальные',
              title: t('table.individual'),
              dataIndex: ROW_FIELD.individual,
              className: 'individual vertical',
              width: 70,
              onCell: (record: any, rowIndex: any) => colSpanValue(record, 0),
              render: (text: any, record: any, index: any) => columnTotalHoursOfThemRender(text, record, index, ROW_FIELD.individual)
            },
          ],
        },
      ],
    },
    {
      title: t('table.hoursBySemester'),
      className: 'hoursBySemester',
      children: [
        {
          title: `1 ${t('table.course')}`,
          className: 'course',
          children: [
            {
              title: `1 ${t('table.sem')}`,
              className: 'semester',
              children: [
                {
                  title: semesterSettingsState?.data?.one ? semesterSettingsState?.data?.one + ' ' + t('table.week') : null,
                  dataIndex: ROW_FIELD.sem_1,
                  className: 'week vertical',
                  width: 70,
                  onCell: (record: any, rowIndex: any) => colSpanValue(record, 0),
                  render: (text: any, record: any, index: any) => columnHoursBySemesterRender(text, record, index, ROW_FIELD.sem_1)
                }
              ]
            },
            {
              title: `2 ${t('table.sem')}`,
              className: 'semester',
              children: [
                {
                  __excelTitle__: '18 нед = 1нед УПС',
                  title: semesterSettingsState?.data?.two ? semesterSettingsState?.data?.two + ' ' + t('table.week') : null,
                  dataIndex: ROW_FIELD.sem_2,
                  className: 'week vertical',
                  width: 70,
                  onCell: (record: any, rowIndex: any) => colSpanValue(record, 0),
                  render: (text: any, record: any, index: any) => columnHoursBySemesterRender(text, record, index, ROW_FIELD.sem_2)
                }
              ]
            }
          ]
        },
        {
          title: `2 ${t('table.course')}`,
          className: 'course',
          children: [
            {
              title: `3 ${t('table.sem')}`,
              className: 'semester',
              children: [
                {
                  __excelTitle__: '12 нед',
                  title:
                    semesterSettingsState?.data?.three ? semesterSettingsState?.data?.three + ' ' + t('table.week') : null,
                  dataIndex: ROW_FIELD.sem_3,
                  width: 70,
                  className: 'week vertical',
                  onCell: (record: any, rowIndex: any) => colSpanValue(record, 0),
                  render: (text: any, record: any, index: any) => columnHoursBySemesterRender(text, record, index, ROW_FIELD.sem_3)
                },
              ],
            },
            {
              title: `4 ${t('table.sem')}`,
              className: 'semester',
              children: [
                {
                  __excelTitle__: '10 нед',
                  title:
                    semesterSettingsState?.data?.four ? semesterSettingsState?.data?.four + ' ' + t('table.week') : null,
                  dataIndex: ROW_FIELD.sem_4,
                  width: 70,
                  className: 'week vertical',
                  onCell: (record: any, rowIndex: any) => colSpanValue(record, 0),
                  render: (text: any, record: any, index: any) => columnHoursBySemesterRender(text, record, index, ROW_FIELD.sem_4)
                },
              ],
            },
          ],
        },
        {
          title: `3 ${t('table.course')}`,
          className: 'course',
          children: [
            {
              title: `5 ${t('table.sem')}`,
              className: 'semester',
              children: [
                {
                  __excelTitle__: '12 нед',
                  title:
                    semesterSettingsState?.data?.five ? semesterSettingsState?.data?.five + ' ' + t('table.week') : null,
                  dataIndex: ROW_FIELD.sem_5,
                  width: 70,
                  className: 'week vertical',
                  onCell: (record: any, rowIndex: any) => colSpanValue(record, 0),
                  render: (text: any, record: any, index: any) => columnHoursBySemesterRender(text, record, index, ROW_FIELD.sem_5)
                }
              ]
            },
            {
              title: `6 ${t('table.sem')}`,
              className: 'semester',
              children: [
                {
                  __excelTitle__: '10 нед',
                  title:
                    semesterSettingsState?.data?.six ? semesterSettingsState?.data?.six + ' ' + t('table.week') : null,
                  dataIndex: ROW_FIELD.sem_6,
                  width: 70,
                  className: 'week vertical',
                  onCell: (record: any, rowIndex: any) => colSpanValue(record, 0),
                  render: (text: any, record: any, index: any) => columnHoursBySemesterRender(text, record, index, ROW_FIELD.sem_6)
                },
              ],
            },
          ],
        },
        {
          title: `4 ${t('table.course')}`,
          className: 'course',
          children: [
            {
              title: `7 ${t('table.sem')}`,
              className: 'semester',
              children: [
                {
                  __excelTitle__: '12 нед',
                  title:
                    semesterSettingsState?.data?.seven ? semesterSettingsState?.data?.seven + ' ' + t('table.week') : null,
                  dataIndex: ROW_FIELD.sem_7,
                  width: 70,
                  className: 'week vertical',
                  onCell: (record: any, rowIndex: any) => colSpanValue(record, 0),
                  render: (text: any, record: any, index: any) => columnHoursBySemesterRender(text, record, index, ROW_FIELD.sem_7)
                },
              ],
            },
            {
              title: `8 ${t('table.sem')}`,
              className: 'semester',
              children: [
                {
                  __excelTitle__: '10 нед',
                  title:
                    semesterSettingsState?.data?.eight ? semesterSettingsState?.data?.eight + ' ' + t('table.week') : null,
                  dataIndex: ROW_FIELD.sem_8,
                  width: 70,
                  className: 'week vertical',
                  onCell: (record: any, rowIndex: any) => colSpanValue(record, 0),
                  render: (text: any, record: any, index: any) => columnHoursBySemesterRender(text, record, index, ROW_FIELD.sem_8)
                },
              ],
            },
          ],
        },
      ],
    },
  ]

  const columnsToExport = [
    {
      title: `${t('table.index')}`,
      dataIndex: 'index',
      // width: '35px',
      // className: 'edited-cell'
    },
    {
      title: `${t('table.moduleAndDisciplineName')}`,
      dataIndex: 'name',
      // width: '200px',
      // className: 'table-text-area'
    },
    {
      title: `${t('table.formControl')}`,
      children: [
        {
          __excelTitle__: 'Экзамен',
          title: t('table.exam'),
          dataIndex: 'exam',
        }, {
          __excelTitle__: 'Зачёт',
          title: t('table.zachet'),
          dataIndex: 'offset',
        }, {
          __excelTitle__: 'Курсовой проект/работа',
          title: t('table.courseProj'),
          dataIndex: 'course_work',
        }, {
          __excelTitle__: 'Контрольная работа',
          title: t('table.courseWork'),
          dataIndex: 'control_work',
        },
      ],
    },
    {
      title: `${t('table.studyTime')}`,
      children: [
        {
          __excelTitle__: 'Кредиты',
          title: t('table.credit'),
          dataIndex: 'credit',
        }, {
          __excelTitle__: 'Всего часов',
          title: t('table.totalHours'),
          dataIndex: 'total_hours',
        }, {
          title: `${t('table.ofThem')}:`,
          children: [
            {
              __excelTitle__: 'Теоретическое обучение',
              title: t('table.theoreticalStudy'),
              dataIndex: 'theoretical_training',
            },
            {
              __excelTitle__: 'Лабораторно-практические работы',
              title: `${t('table.laboratoryAndPractical')}} ${t('table.work')}`,
              dataIndex: 'lab_pract_work',
            },
            {
              __excelTitle__: 'Курсовые проекты и работы',
              title: t('table.coursesProjAndWork'),
              dataIndex: 'course_projects',
            },
            {
              __excelTitle__: 'Производственное обучение',
              title: t('table.industrialTraining'),
              dataIndex: 'industrial_training',
            },
            {
              __excelTitle__: 'Профессиональная практика',
              title: t('table.professionalPractice'),
              dataIndex: 'professional_training',
            },
            {
              __excelTitle__: 'Индивидуальные',
              title: t('table.individual'),
              dataIndex: 'individual',
            },
          ],
        },
      ],
    },
    {
      title: t('table.hoursBySemester'),
      children: [
        {
          title: `1 ${t('table.course')}`,
          children: [
            {
              title: `1 ${t('table.sem')}`,
              children: [
                {
                  __excelTitle__: '20 нед',
                  title: `20 ${t('table.week')}`,
                  dataIndex: 'sem_1',
                }
              ]
            },
            {
              title: `2 ${t('table.sem')}`,
              children: [
                {
                  __excelTitle__: '18 нед = 1нед УПС',
                  title: t('table.week18'),
                  dataIndex: 'sem_2',
                }
              ]
            }
          ]
        }, {
          title: `2 ${t('table.course')}`,
          children: [
            {
              title: `3 ${t('table.sem')}`,
              children: [
                {
                  __excelTitle__: '12 нед',
                  title: `12 ${t('table.med')}`,
                  dataIndex: 'sem_3',
                },
              ],
            },
            {
              title: `4 ${t('table.sem')}`,
              children: [
                {
                  __excelTitle__: '10 нед',
                  title: `10 ${t('table.med')}`,
                  dataIndex: 'sem_4',
                },
              ],
            },
          ],
        }, {
          title: `3 ${t('table.course')}`,
          children: [
            {
              title: `5 ${t('table.sem')}`,
              children: [
                {
                  __excelTitle__: '12 нед',
                  title: `12 ${t('table.med')}`,
                  dataIndex: 'sem_5',
                }
              ]
            },
            {
              title: `6 ${t('table.sem')}`,
              children: [
                {
                  __excelTitle__: '10 нед',
                  title: `10 ${t('table.med')}`,
                  dataIndex: 'sem_6',
                },
              ],
            },
          ],
        }, {
          title: `4 ${t('table.course')}`,
          children: [
            {
              title: `7 ${t('table.sem')}`,
              children: [
                {
                  __excelTitle__: '12 нед',
                  title: `12 ${t('table.med')}`,
                  dataIndex: 'sem_7',
                },
              ],
            },
            {
              title: `8 ${t('table.sem')}`,
              children: [
                {
                  __excelTitle__: '10 нед',
                  title: `10 ${t('table.med')}`,
                  dataIndex: 'sem_8',
                },
              ],
            },
          ],
        },
      ],
    },
  ]

  const onSuccessHandler = (func: () => void) => {
    setIsEditedRup(false)
    setChangedArray([])
    if (changedArray.length > 0) {
      dispatch(editRow(changedArray))
    }

    func()
  }

  const onFailedHandler = (func: () => void) => {
    setIsEditedRup(false)
    setChangedArray([])
    setCurrentDataTable(cloneRupTableState.data)

    func()
  }

  const handleBackToAllRups = useCallback(() => {
    const func = () => {
      const path = {
        // @ts-ignore
        pathname: generatePath(ROUTE_PATH.RUP),
      }

      navigate(path)
      dispatch(resetNewRupState())
    }

    if (isEditedRup) {
      handleModal(() => onSuccessHandler(func), () => onFailedHandler(func))
    } else {
      func()
      dispatch(resetNewRupState())
    }
  }, [changedArray, cloneRupTableState])

  const handleBackToQualifications = useCallback(() => {
    const func = () => {
      const path = {
        // @ts-ignore
        pathname: generatePath(ROUTE_PATH.RUP_QUALIFICATION, {rupId}),
      }

      navigate(path)
    }

    if (isEditedRup) {
      handleModal(() => onSuccessHandler(func), () => onFailedHandler(func))
    } else {
      func()
      dispatch(resetNewRupState())
    }
  }, [changedArray, cloneRupTableState])

  const handleChangeTab = useCallback((key: string) => {
    setCurrentTab(key)

    switch (key) {
      case '3':
        dispatch(getRupInfo(rupId))
        break

      default:
        return false
    }
  }, [])

  const handleExport = useCallback(() => {
    const excel = new Excel();
    excel
      .addSheet(currentRupState?.data?.name)
      // @ts-ignore
      .addColumns(columnsToExport)
      .addDataSource(currentDataTable)
      .saveAs(`Группа-${currentRupState?.data?.name}.xlsx`);
  }, [columnsToExport, currentDataTable])

  const handleEdit = useCallback(() => {
    setIsEditedRup(true)
  }, [])

  const handleModal = useCallback((onOkHandle: () => void, onCancelHandle: () => void) => {
    Modal.confirm({
      title: `${t('saveQuestion')}`,
      okText: `${t('button.save')}`,
      cancelText: `${t('reject')}`,
      okType: 'primary',
      centered: true,
      onOk: () => {
        onOkHandle()
      },
      onCancel: () => {
        onCancelHandle()
      }
    })
  }, [])

  const handleSave = useCallback(() => {
    handleModal(() => onSuccessHandler(() => {}), () => onFailedHandler(() => {}))
  }, [changedArray, cloneRupTableState])

  const handleAddRowDiscipline = useCallback((record: any, index: any) => {
    dispatch(createNewDisciplineRow(record.key))
  }, [])

  const handleAddRow = useCallback((record: any, index: any) => {
    switch (record.row_type) {
      case ROW_TYPE.discipline:
      case ROW_TYPE.discipline_evelated:
        dispatch(createNewRow(record.parent_id))
        break
      case ROW_TYPE.discipline_from_module:
        dispatch(createNewDisciplineRow(record.parent_id))
        break
      default:
        dispatch(createNewRow(record.key))
        break
    }
  }, [])

  const handleAddModuleWithoutDiscipline = useCallback((record: any, index: any) => {
    dispatch(addModuleWithoutDisc(record.key))
  }, [])

  const handleDeleteRow = useCallback((record: any, index: any) => {
    dispatch(deleteRow({key: record.key, rup_id: rupId}))
  }, [])

  const toFloat = useCallback((num: any) => {
    let number = parseFloat(num)
    return Math.round(number * 100) / 100
  }, [])

  const toFloatWithStep = useCallback((num: any) => {
      let number = parseFloat(num)
      return Math.round(number);
    }
    , [])

  const textDangerClass = useCallback((record: any) => {
    let credit = (Math.ceil(record.credit * 24))
    let conditionHoursOfThem = credit < (parseInt(record.theoretical_training) + parseInt(record.lab_pract_work) + parseInt(record.course_projects) + parseInt(record.industrial_training) + parseInt(record.professional_training) + parseInt(record.individual) + parseInt(record.srsp))
    let conditionSemester = credit < (parseInt(record.sem_1) + parseInt(record.sem_2) + parseInt(record.sem_3) + parseInt(record.sem_4) + parseInt(record.sem_5) + parseInt(record.sem_6) + parseInt(record.sem_7) + parseInt(record.sem_8))
    let conditionHoursOfSrs = (parseInt(record.theoretical_training) + parseInt(record.lab_pract_work) + parseInt(record.course_projects) + parseInt(record.industrial_training) + parseInt(record.professional_training) + parseInt(record.individual) + parseInt(record.srsp) + parseInt(record.srs)) < (parseInt(record.sem_1) + parseInt(record.sem_2) + parseInt(record.sem_3) + parseInt(record.sem_4) + parseInt(record.sem_5) + parseInt(record.sem_6) + parseInt(record.sem_7) + parseInt(record.sem_8))


    return (conditionHoursOfSrs) ? 'text-danger' : ''
  }, [])

  const findTotalOfArray = useCallback((array: any, key: any) => {
    return array.reduce((total: any, obj: any) => {
      return toFloat(total) + toFloat(obj[key])
    }, 0)
  }, [])

  const setHours = useCallback((value: any) => {
    const floatValue = toFloat(value) ? toFloat(value) : 0
    return Math.round(floatValue * 24)
  }, [])

  const filterTupAndTotal = (arr: any[]) => {
    return arr.filter((item: any) => item.row_type !== ROW_TYPE.row_from_tup).filter((item: any) => item.row_type !== ROW_TYPE.qualification_total && item.row_type !== ROW_TYPE.qualification_evelated_total)
  }

  const setValues = useCallback((body: any) => {
    const {id, value, key, record, index} = body

    let initialValue: any = ''
    let result: any[] = []

    let arrayOfLevel1: any[] = []
    let itemOfLevel1: any = {}

    let arrayOfLevel2: any[] = []
    let itemOfLevel2: any = {}

    let arrayOfLevel3: any[] = []
    let itemOfLevel3: any = {}

    let arrayOfLevel4: any[] = []
    let itemOfLevel4: any = {}

    let arrayOfLevel5: any[] = []
    let itemOfLevel5: any = {}

    if (key === ROW_FIELD.discipline_id) {
      initialValue = value ? value : {id: null, caption: ''}
    } else if (key === ROW_FIELD.name) {
      initialValue = value ? value : ''
    } else if (key === ROW_FIELD.exam || key === ROW_FIELD.offset || key === ROW_FIELD.course_work || key === ROW_FIELD.control_work) {
      initialValue = Array.isArray(value) ? value.length > 0 ? value.join(',') : '' : value
    } else {
      initialValue = toFloat(value) ? toFloat(value) : 0
    }

    let newArr = structuredClone(currentDataTable)

    newArr.map((item: any) => {
      if (item.key === record.key) {
        if (key === ROW_FIELD.discipline_id) {
          item[ROW_FIELD.discipline_id] = value.id
          item[ROW_FIELD.name] = value.caption
          item[ROW_FIELD.caption_current] = value.caption
        } else {
          item[key] = initialValue
        }
      }
    })

    const objectResult = (recordObj: any, currentKey: any, withHours?: boolean) => {
      return {
        id: recordObj.key,
        value: withHours ? setHours(newArr.find((item: any) => item.key === recordObj.key)[currentKey]) : newArr.find((item: any) => item.key === recordObj.key)[currentKey],
        key: withHours ? ROW_FIELD.total_hours : currentKey,
        record: recordObj,
        index: newArr.findIndex((item: any) => item.key === recordObj[ROW_FIELD.key]),
      }
    }

    switch (key) {
      case ROW_FIELD.discipline_id:
        let nameBody = [{
          id: id,
          value: initialValue.id,
          key,
          record,
          index
        }, {
          id: id,
          value: initialValue.caption,
          key: ROW_FIELD.name,
          record,
          index
        }]

        setChangedValue(nameBody)
        setCurrentDataTable(newArr)
        return result = [...nameBody]

      case ROW_FIELD.index:
      case ROW_FIELD.name:
        setChangedValue(body)
        setCurrentDataTable(newArr)
        return result = [body]

      case ROW_FIELD.exam:
      case ROW_FIELD.offset:
      case ROW_FIELD.course_work:
      case ROW_FIELD.control_work:
        let arrValueBody = {
          ...body,
          value: Array.isArray(body.value) ? body.value.length > 0 ? body.value.join(',') : '' : body.value
        }
        setChangedValue(arrValueBody)
        setCurrentDataTable(newArr)
        return result = [arrValueBody]

      case ROW_FIELD.credit:
      case ROW_FIELD.sem_1:
      case ROW_FIELD.sem_2:
      case ROW_FIELD.sem_3:
      case ROW_FIELD.sem_4:
      case ROW_FIELD.sem_5:
      case ROW_FIELD.sem_6:
      case ROW_FIELD.sem_7:
      case ROW_FIELD.sem_8:
        switch (record.row_type) {
          case ROW_TYPE.discipline_evelated:
            itemOfLevel1 = record
            itemOfLevel2 = newArr.find((item: any) => itemOfLevel1?.parent_id === item.key)
            itemOfLevel3 = newArr.filter((item: any) => itemOfLevel2.parent_id === item.parent_id).find((item: any) => item.row_type === ROW_TYPE.qualification_evelated_total || item.row_type === ROW_TYPE.qualification_total)

            arrayOfLevel1 = filterTupAndTotal(newArr).filter((item: any) => itemOfLevel1?.parent_id === item.parent_id)
            arrayOfLevel2 = filterTupAndTotal(newArr).filter((item: any) => itemOfLevel2?.parent_id === item.parent_id)

            newArr.map((item: any) => {
              if (item.key === itemOfLevel2?.key) {
                item[key] = findTotalOfArray(arrayOfLevel1, key)
              }
            })

            newArr.map((item: any) => {
              if (item.key === itemOfLevel3?.key) {
                item[key] = findTotalOfArray(arrayOfLevel2, key)
              }
            })

            if (key === ROW_FIELD.credit) {
              result.push(
                objectResult(itemOfLevel1, key, true),
                objectResult(itemOfLevel2, key, true),
                objectResult(itemOfLevel3, key, true),
              )
            }

            setCurrentDataTable(newArr)

            return result = [
              objectResult(itemOfLevel1, key),
              objectResult(itemOfLevel2, key),
              objectResult(itemOfLevel3, key),
              ...result
            ]

          case ROW_TYPE.ro:
          case ROW_TYPE.discipline_from_module:
            itemOfLevel1 = record
            itemOfLevel2 = newArr.find((item: any) => itemOfLevel1?.parent_id === item.key)
            itemOfLevel3 = newArr.find((item: any) => itemOfLevel2?.parent_id === item.key)
            itemOfLevel4 = newArr.filter((item: any) => itemOfLevel3.parent_id === item.parent_id).find((item: any) => item.row_type === ROW_TYPE.qualification_evelated_total || item.row_type === ROW_TYPE.qualification_total)

            arrayOfLevel1 = filterTupAndTotal(newArr).filter((item: any) => itemOfLevel1?.parent_id === item.parent_id)
            arrayOfLevel2 = filterTupAndTotal(newArr).filter((item: any) => itemOfLevel2?.parent_id === item.parent_id)
            arrayOfLevel3 = filterTupAndTotal(newArr).filter((item: any) => itemOfLevel3?.parent_id === item.parent_id)


            newArr.map((item: any) => {
              if (item.key === itemOfLevel2?.key) {
                item[key] = findTotalOfArray(arrayOfLevel1, key)
              }
            })

            newArr.map((item: any) => {
              if (item.key === itemOfLevel3?.key) {
                item[key] = findTotalOfArray(arrayOfLevel2, key)
              }
            })

            newArr.map((item: any) => {
              if (item.key === itemOfLevel4?.key) {
                item[key] = findTotalOfArray(arrayOfLevel3, key)
              }
            })

            if (key === ROW_FIELD.credit) {
              result.push(
                objectResult(itemOfLevel1, key, true),
                objectResult(itemOfLevel2, key, true),
                objectResult(itemOfLevel3, key, true),
                objectResult(itemOfLevel4, key, true),
              )
            }

            setCurrentDataTable(newArr)

            return result = [
              objectResult(itemOfLevel1, key),
              objectResult(itemOfLevel2, key),
              objectResult(itemOfLevel3, key),
              objectResult(itemOfLevel4, key),
              ...result
            ]

          case ROW_TYPE.row_from_tup:
            itemOfLevel1 = record
            arrayOfLevel1 = newArr.filter((item: any) => itemOfLevel1?.parent_id === item.parent_id)

            if (key === ROW_FIELD.credit) {
              result.push(objectResult(itemOfLevel1, key, true))
            }

            setCurrentDataTable(newArr)

            return result = [
              objectResult(itemOfLevel1, key),
              ...result
            ]

          case ROW_TYPE.discipline:
            itemOfLevel1 = record
            itemOfLevel2 = newArr.find((item: any) => itemOfLevel1?.parent_id === item.key)
            itemOfLevel3 = newArr.find((item: any) => itemOfLevel2?.parent_id === item.key)
            itemOfLevel4 = newArr.find((item: any) => itemOfLevel3?.parent_id === item.key)
            itemOfLevel5 = newArr.filter((item: any) => itemOfLevel4.parent_id === item.parent_id).find((item: any) => item.row_type === ROW_TYPE.qualification_evelated_total || item.row_type === ROW_TYPE.qualification_total)

            arrayOfLevel1 = filterTupAndTotal(newArr).filter((item: any) => itemOfLevel1?.parent_id === item.parent_id)
            arrayOfLevel2 = filterTupAndTotal(newArr).filter((item: any) => itemOfLevel2?.parent_id === item.parent_id)
            arrayOfLevel3 = filterTupAndTotal(newArr).filter((item: any) => itemOfLevel3?.parent_id === item.parent_id)
            arrayOfLevel4 = filterTupAndTotal(newArr).filter((item: any) => itemOfLevel4?.parent_id === item.parent_id)

            newArr.map((item: any) => {
              if (item.key === itemOfLevel2?.key) {
                item[key] = findTotalOfArray(arrayOfLevel1, key)
              }
            })

            newArr.map((item: any) => {
              if (item.key === itemOfLevel3?.key) {
                item[key] = findTotalOfArray(arrayOfLevel2, key)
              }
            })

            newArr.map((item: any) => {
              if (item.key === itemOfLevel4?.key) {
                item[key] = findTotalOfArray(arrayOfLevel3, key)
              }
            })

            newArr.map((item: any) => {
              if (item.key === itemOfLevel5?.key) {
                item[key] = findTotalOfArray(arrayOfLevel4, key)
              }
            })

            if (key === ROW_FIELD.credit) {
              result.push(
                objectResult(itemOfLevel1, key, true),
                objectResult(itemOfLevel2, key, true),
                objectResult(itemOfLevel3, key, true),
                objectResult(itemOfLevel4, key, true),
                objectResult(itemOfLevel5, key, true),
              )
            }

            setCurrentDataTable(newArr)

            return result = [
              objectResult(itemOfLevel1, key),
              objectResult(itemOfLevel2, key),
              objectResult(itemOfLevel3, key),
              objectResult(itemOfLevel4, key),
              objectResult(itemOfLevel5, key),
              ...result
            ]

          default:
            setCurrentDataTable(newArr)
            return result
        }

      case ROW_FIELD.theoretical_training:
      case ROW_FIELD.lab_pract_work:
      case ROW_FIELD.course_projects:
      case ROW_FIELD.industrial_training:
      case ROW_FIELD.professional_training:
      case ROW_FIELD.individual:
      case ROW_FIELD.srs:
      case ROW_FIELD.srsp:

        let theoretical_training = newArr.find((i: any) => i.key === record.key)[ROW_FIELD.theoretical_training]
        let lab_pract_work = newArr.find((i: any) => i.key === record.key)[ROW_FIELD.lab_pract_work]
        let course_projects = newArr.find((i: any) => i.key === record.key)[ROW_FIELD.course_projects]
        let industrial_training = newArr.find((i: any) => i.key === record.key)[ROW_FIELD.industrial_training]
        let professional_training = newArr.find((i: any) => i.key === record.key)[ROW_FIELD.professional_training]
        let individual = newArr.find((i: any) => i.key === record.key)[ROW_FIELD.individual]
        let srsp = newArr.find((i: any) => i.key === record.key)[ROW_FIELD.srsp]

        let totalHour = theoretical_training + lab_pract_work + course_projects + industrial_training + professional_training + individual + srsp

        newArr.map((item: any) => {
          if (item.key === record?.key) {
            item[ROW_FIELD.credit] = toFloat(totalHour / 24)
            item[ROW_FIELD.total_hours] = totalHour
          }
        })

        switch (record.row_type) {
          case ROW_TYPE.discipline_evelated:
            itemOfLevel1 = record
            itemOfLevel2 = newArr.find((item: any) => itemOfLevel1?.parent_id === item.key)
            itemOfLevel3 = newArr.filter((item: any) => itemOfLevel2.parent_id === item.parent_id).find((item: any) => item.row_type === ROW_TYPE.qualification_evelated_total || item.row_type === ROW_TYPE.qualification_total)

            arrayOfLevel1 = filterTupAndTotal(newArr).filter((item: any) => itemOfLevel1?.parent_id === item.parent_id)
            arrayOfLevel2 = filterTupAndTotal(newArr).filter((item: any) => itemOfLevel2?.parent_id === item.parent_id)

            newArr.map((item: any) => {
              if (item.key === itemOfLevel2?.key) {
                item[key] = findTotalOfArray(arrayOfLevel1, key)
                item[ROW_FIELD.credit] = findTotalOfArray(arrayOfLevel1, ROW_FIELD.credit)
                item[ROW_FIELD.total_hours] = findTotalOfArray(arrayOfLevel1, ROW_FIELD.total_hours)
              }
            })

            newArr.map((item: any) => {
              if (item.key === itemOfLevel3?.key) {
                item[key] = findTotalOfArray(arrayOfLevel2, key)
                item[ROW_FIELD.credit] = findTotalOfArray(arrayOfLevel2, ROW_FIELD.credit)
                item[ROW_FIELD.total_hours] = findTotalOfArray(arrayOfLevel2, ROW_FIELD.total_hours)
              }
            })

            setCurrentDataTable(newArr)

            return result = [
              objectResult(itemOfLevel1, key),
              objectResult(itemOfLevel2, key),
              objectResult(itemOfLevel3, key),

              objectResult(itemOfLevel1, ROW_FIELD.credit),
              objectResult(itemOfLevel2, ROW_FIELD.credit),
              objectResult(itemOfLevel3, ROW_FIELD.credit),

              objectResult(itemOfLevel1, ROW_FIELD.total_hours),
              objectResult(itemOfLevel2, ROW_FIELD.total_hours),
              objectResult(itemOfLevel3, ROW_FIELD.total_hours),
              ...result
            ]

          case ROW_TYPE.ro:
          case ROW_TYPE.discipline_from_module:
            itemOfLevel1 = record
            itemOfLevel2 = newArr.find((item: any) => itemOfLevel1?.parent_id === item.key)
            itemOfLevel3 = newArr.find((item: any) => itemOfLevel2?.parent_id === item.key)
            itemOfLevel4 = newArr.filter((item: any) => itemOfLevel3.parent_id === item.parent_id).find((item: any) => item.row_type === ROW_TYPE.qualification_evelated_total || item.row_type === ROW_TYPE.qualification_total)

            arrayOfLevel1 = filterTupAndTotal(newArr).filter((item: any) => itemOfLevel1?.parent_id === item.parent_id)
            arrayOfLevel2 = filterTupAndTotal(newArr).filter((item: any) => itemOfLevel2?.parent_id === item.parent_id)
            arrayOfLevel3 = filterTupAndTotal(newArr).filter((item: any) => itemOfLevel3?.parent_id === item.parent_id)


            newArr.map((item: any) => {
              if (item.key === itemOfLevel2?.key) {
                item[key] = findTotalOfArray(arrayOfLevel1, key)
                item[ROW_FIELD.credit] = findTotalOfArray(arrayOfLevel1, ROW_FIELD.credit)
                item[ROW_FIELD.total_hours] = findTotalOfArray(arrayOfLevel1, ROW_FIELD.total_hours)
              }
            })

            newArr.map((item: any) => {
              if (item.key === itemOfLevel3?.key) {
                item[key] = findTotalOfArray(arrayOfLevel2, key)
                item[ROW_FIELD.credit] = findTotalOfArray(arrayOfLevel2, ROW_FIELD.credit)
                item[ROW_FIELD.total_hours] = findTotalOfArray(arrayOfLevel2, ROW_FIELD.total_hours)
              }
            })

            newArr.map((item: any) => {
              if (item.key === itemOfLevel4?.key) {
                item[key] = findTotalOfArray(arrayOfLevel3, key)
                item[ROW_FIELD.credit] = findTotalOfArray(arrayOfLevel3, ROW_FIELD.credit)
                item[ROW_FIELD.total_hours] = findTotalOfArray(arrayOfLevel3, ROW_FIELD.total_hours)
              }
            })

            setCurrentDataTable(newArr)

            return result = [
              objectResult(itemOfLevel1, key),
              objectResult(itemOfLevel2, key),
              objectResult(itemOfLevel3, key),
              objectResult(itemOfLevel4, key),

              objectResult(itemOfLevel1, ROW_FIELD.credit),
              objectResult(itemOfLevel2, ROW_FIELD.credit),
              objectResult(itemOfLevel3, ROW_FIELD.credit),
              objectResult(itemOfLevel4, ROW_FIELD.credit),

              objectResult(itemOfLevel1, ROW_FIELD.total_hours),
              objectResult(itemOfLevel2, ROW_FIELD.total_hours),
              objectResult(itemOfLevel3, ROW_FIELD.total_hours),
              objectResult(itemOfLevel4, ROW_FIELD.total_hours),
              ...result
            ]

          case ROW_TYPE.row_from_tup:
            itemOfLevel1 = record
            arrayOfLevel1 = newArr.filter((item: any) => itemOfLevel1?.parent_id === item.parent_id)

            setCurrentDataTable(newArr)

            return result = [
              objectResult(itemOfLevel1, key),
              ...result
            ]

          case ROW_TYPE.discipline:
            itemOfLevel1 = record
            itemOfLevel2 = newArr.find((item: any) => itemOfLevel1?.parent_id === item.key)
            itemOfLevel3 = newArr.find((item: any) => itemOfLevel2?.parent_id === item.key)
            itemOfLevel4 = newArr.find((item: any) => itemOfLevel3?.parent_id === item.key)
            itemOfLevel5 = newArr.filter((item: any) => itemOfLevel4.parent_id === item.parent_id).find((item: any) => item.row_type === ROW_TYPE.qualification_evelated_total || item.row_type === ROW_TYPE.qualification_total)

            arrayOfLevel1 = filterTupAndTotal(newArr).filter((item: any) => itemOfLevel1?.parent_id === item.parent_id)
            arrayOfLevel2 = filterTupAndTotal(newArr).filter((item: any) => itemOfLevel2?.parent_id === item.parent_id)
            arrayOfLevel3 = filterTupAndTotal(newArr).filter((item: any) => itemOfLevel3?.parent_id === item.parent_id)
            arrayOfLevel4 = filterTupAndTotal(newArr).filter((item: any) => itemOfLevel4?.parent_id === item.parent_id)

            newArr.map((item: any) => {
              if (item.key === itemOfLevel2?.key) {
                item[key] = findTotalOfArray(arrayOfLevel1, key)
                item[ROW_FIELD.credit] = findTotalOfArray(arrayOfLevel1, ROW_FIELD.credit)
                item[ROW_FIELD.total_hours] = findTotalOfArray(arrayOfLevel1, ROW_FIELD.total_hours)
              }
            })

            newArr.map((item: any) => {
              if (item.key === itemOfLevel3?.key) {
                item[key] = findTotalOfArray(arrayOfLevel2, key)
                item[ROW_FIELD.credit] = findTotalOfArray(arrayOfLevel2, ROW_FIELD.credit)
                item[ROW_FIELD.total_hours] = findTotalOfArray(arrayOfLevel2, ROW_FIELD.total_hours)
              }
            })

            newArr.map((item: any) => {
              if (item.key === itemOfLevel4?.key) {
                item[key] = findTotalOfArray(arrayOfLevel3, key)
                item[ROW_FIELD.credit] = findTotalOfArray(arrayOfLevel3, ROW_FIELD.credit)
                item[ROW_FIELD.total_hours] = findTotalOfArray(arrayOfLevel3, ROW_FIELD.total_hours)
              }
            })

            newArr.map((item: any) => {
              if (item.key === itemOfLevel5?.key) {
                item[key] = findTotalOfArray(arrayOfLevel4, key)
                item[ROW_FIELD.credit] = findTotalOfArray(arrayOfLevel4, ROW_FIELD.credit)
                item[ROW_FIELD.total_hours] = findTotalOfArray(arrayOfLevel4, ROW_FIELD.total_hours)
              }
            })

            setCurrentDataTable(newArr)

            return result = [
              objectResult(itemOfLevel1, key),
              objectResult(itemOfLevel2, key),
              objectResult(itemOfLevel3, key),
              objectResult(itemOfLevel4, key),
              objectResult(itemOfLevel5, key),

              objectResult(itemOfLevel1, ROW_FIELD.credit),
              objectResult(itemOfLevel2, ROW_FIELD.credit),
              objectResult(itemOfLevel3, ROW_FIELD.credit),
              objectResult(itemOfLevel4, ROW_FIELD.credit),
              objectResult(itemOfLevel5, ROW_FIELD.credit),

              objectResult(itemOfLevel1, ROW_FIELD.total_hours),
              objectResult(itemOfLevel2, ROW_FIELD.total_hours),
              objectResult(itemOfLevel3, ROW_FIELD.total_hours),
              objectResult(itemOfLevel4, ROW_FIELD.total_hours),
              objectResult(itemOfLevel5, ROW_FIELD.total_hours),
              ...result
            ]

          default:
            setCurrentDataTable(newArr)
            return result
        }

      default:
        console.log('smthng wrong', body)
        break
    }
  }, [currentDataTable])

  const filterArrayByUniqueIDAndKey = useCallback((arr: any) => {
    return arr.reduce((acc: any, curr: any) => {
      const duplicateIndex = acc.findIndex((item: any) => item.id === curr.id && item.key === curr.key);
      if (duplicateIndex !== -1) {
        acc[duplicateIndex].value = curr.value;
      } else {
        acc.push(curr);
      }
      return acc;
    }, [])
  }, [])

  const setChangedArrayHandler = useCallback((array: any) => {
    setChangedArray((prevState) => filterArrayByUniqueIDAndKey([...prevState, ...array]))
  }, [])

  const handleChange = useCallback((value: any, key: any, record: any, index: any) => {
    let body = {
      id: record.key,
      value: value,
      key,
      record,
      index
    }

    setChangedArrayHandler(setValues(body))
  }, [currentDataTable])

  const handleEnter = useCallback((e: any) => {
    let neededArray = inputsRef.current.filter((inputs: any) => {
      return inputs.input.id === e.target.id
    })

    let lengthArray = inputsRef?.current?.length

    let focusOn = inputsRef?.current?.indexOf(neededArray[0])

    // @ts-ignore
    inputsRef?.current[focusOn === (lengthArray - 1) ? 0 : focusOn + 1]?.focus()
  }, [])

  const handleSetRefs = useCallback((el: any) => {
    // @ts-ignore
    if (el && !inputsRef.current.includes(el)) {
      // @ts-ignore
      inputsRef.current.push(el)
    }
  }, [])

  const handleKeyPress = useCallback((e: any) => {
    switch (e.code){
      case 'NumpadSubtract':
      case 'Minus':
      case 'NumpadAdd':
      case 'Plus':
      case 'Equal':
      case 'KeyE':
        e.preventDefault();
        break

      case 'ArrowUp':
      case 'ArrowDown':
      case 'ArrowRight':
      case 'ArrowLeft':
        break

      default:
        break
    }

  }, [])

  const handleKeyDown = useCallback((e: any) => {
    switch (e.code){
      case 'ArrowUp':
      case 'ArrowDown':
      case 'ArrowRight':
      case 'ArrowLeft':
        break

      default:
        break
    }

  }, [])

  //columns
  const colSpanValue = useCallback((record: any, span: any) => {
    switch (record.row_type) {
      case ROW_TYPE.qualification:
      case ROW_TYPE.qualification_evelated:
        return {
          colSpan: span
        }
    }
  }, [currentDataTable])

  const rowClassName = useCallback((record: any) => {
    switch (record.row_type) {
      case ROW_TYPE.qualification:
      case ROW_TYPE.qualification_total:
      case ROW_TYPE.group:
      case ROW_TYPE.module:
      case ROW_TYPE.module_evelated:
      case ROW_TYPE.qualification_evelated:
      case ROW_TYPE.ro:
      case ROW_TYPE.discipline:
      case ROW_TYPE.discipline_from_module:
      case ROW_TYPE.discipline_evelated:
      case ROW_TYPE.qualification_evelated_total:
      case ROW_TYPE.row_from_tup:
        return record.row_type
      default:
        return 'strange-color'
    }
  }, [currentDataTable])

  const summary = useCallback((pageData: any) => {
    let totalCredit = 0
    let totalTotal_hours = 0
    let totalTheoretical_training = 0
    let totalLab_pract_work = 0
    let totalCourse_projects = 0
    let totalIndustrial_training = 0
    let totalProfessional_training = 0
    let totalIndividual = 0
    let totalSem_1 = 0
    let totalSem_2 = 0
    let totalSem_3 = 0
    let totalSem_4 = 0
    let totalSem_5 = 0
    let totalSem_6 = 0
    let totalSem_7 = 0
    let totalSem_8 = 0
    let totalSrs = 0
    let totalSrsp = 0

    totalCredit = pageData.reduce((total: any, obj: any) => {
      return (obj.row_type === ROW_TYPE.qualification_total || obj.row_type === ROW_TYPE.qualification_evelated_total) ? parseInt(total) + parseInt(obj.credit) : parseInt(total)
    }, 0)

    totalTotal_hours = pageData.reduce((total: any, obj: any) => {
      return (obj.row_type === ROW_TYPE.qualification_total || obj.row_type === ROW_TYPE.qualification_evelated_total) ? parseInt(total) + (parseInt(obj.theoretical_training) + parseInt(obj.lab_pract_work) + parseInt(obj.course_projects) + parseInt(obj.industrial_training) + parseInt(obj.professional_training) + parseInt(obj.individual) + parseInt(obj.srsp)) : parseInt(total)
    }, 0)

    totalTheoretical_training = pageData.reduce((total: any, obj: any) => {
      return (obj.row_type === ROW_TYPE.group || obj.row_type === ROW_TYPE.module_evelated) ? parseInt(total) + parseInt(obj.theoretical_training) : parseInt(total)
    }, 0)

    totalLab_pract_work = pageData.reduce((total: any, obj: any) => {
      return (obj.row_type === ROW_TYPE.group || obj.row_type === ROW_TYPE.module_evelated) ? parseInt(total) + parseInt(obj.lab_pract_work) : parseInt(total)
    }, 0)

    totalCourse_projects = pageData.reduce((total: any, obj: any) => {
      return (obj.row_type === ROW_TYPE.group || obj.row_type === ROW_TYPE.module_evelated) ? parseInt(total) + parseInt(obj.course_projects) : parseInt(total)
    }, 0)

    totalIndustrial_training = pageData.reduce((total: any, obj: any) => {
      return (obj.row_type === ROW_TYPE.group || obj.row_type === ROW_TYPE.module_evelated) ? parseInt(total) + parseInt(obj.industrial_training) : parseInt(total)
    }, 0)

    totalProfessional_training = pageData.reduce((total: any, obj: any) => {
      return (obj.row_type === ROW_TYPE.group || obj.row_type === ROW_TYPE.module_evelated) ? parseInt(total) + parseInt(obj.professional_training) : parseInt(total)
    }, 0)

    totalIndividual = pageData.reduce((total: any, obj: any) => {
      return (obj.row_type === ROW_TYPE.group || obj.row_type === ROW_TYPE.module_evelated) ? parseInt(total) + parseInt(obj.individual) : parseInt(total)
    }, 0)

    totalSrs = pageData.reduce((total: any, obj: any) => {
      return (obj.row_type === ROW_TYPE.group || obj.row_type === ROW_TYPE.module_evelated) ? parseInt(total) + parseInt(obj.srs) : parseInt(total)
    }, 0)

    totalSrsp = pageData.reduce((total: any, obj: any) => {
      return (obj.row_type === ROW_TYPE.group || obj.row_type === ROW_TYPE.module_evelated) ? parseInt(total) + parseInt(obj.srsp) : parseInt(total)
    }, 0)

    totalSem_1 = pageData.reduce((total: any, obj: any) => {
      return (obj.row_type === ROW_TYPE.qualification_total || obj.row_type === ROW_TYPE.qualification_evelated_total) ? parseInt(total) + parseInt(obj.sem_1) : parseInt(total)
    }, 0)

    totalSem_2 = pageData.reduce((total: any, obj: any) => {
      return (obj.row_type === ROW_TYPE.qualification_total || obj.row_type === ROW_TYPE.qualification_evelated_total) ? parseInt(total) + parseInt(obj.sem_2) : parseInt(total)
    }, 0)

    totalSem_3 = pageData.reduce((total: any, obj: any) => {
      return (obj.row_type === ROW_TYPE.qualification_total || obj.row_type === ROW_TYPE.qualification_evelated_total) ? parseInt(total) + parseInt(obj.sem_3) : parseInt(total)
    }, 0)

    totalSem_4 = pageData.reduce((total: any, obj: any) => {
      return (obj.row_type === ROW_TYPE.qualification_total || obj.row_type === ROW_TYPE.qualification_evelated_total) ? parseInt(total) + parseInt(obj.sem_4) : parseInt(total)
    }, 0)

    totalSem_5 = pageData.reduce((total: any, obj: any) => {
      return (obj.row_type === ROW_TYPE.qualification_total || obj.row_type === ROW_TYPE.qualification_evelated_total) ? parseInt(total) + parseInt(obj.sem_5) : parseInt(total)
    }, 0)

    totalSem_6 = pageData.reduce((total: any, obj: any) => {
      return (obj.row_type === ROW_TYPE.qualification_total || obj.row_type === ROW_TYPE.qualification_evelated_total) ? parseInt(total) + parseInt(obj.sem_6) : parseInt(total)
    }, 0)

    totalSem_7 = pageData.reduce((total: any, obj: any) => {
      return (obj.row_type === ROW_TYPE.qualification_total || obj.row_type === ROW_TYPE.qualification_evelated_total) ? parseInt(total) + parseInt(obj.sem_7) : parseInt(total)
    }, 0)

    totalSem_8 = pageData.reduce((total: any, obj: any) => {
      return (obj.row_type === ROW_TYPE.qualification_total || obj.row_type === ROW_TYPE.qualification_evelated_total) ? parseInt(total) + parseInt(obj.sem_8) : parseInt(total)
    }, 0)

    return (
      <Table.Summary.Row>
        <Table.Summary.Cell index={0}>
        </Table.Summary.Cell>
        <Table.Summary.Cell index={1}>
        </Table.Summary.Cell>
        <Table.Summary.Cell index={2}>
          <MyText size={18} color='#51258F' weight={700}>
            {t('select.total.placeholder')}
          </MyText>
        </Table.Summary.Cell>
        <Table.Summary.Cell index={3}>
        </Table.Summary.Cell>
        <Table.Summary.Cell index={4}>
        </Table.Summary.Cell>
        <Table.Summary.Cell index={5}>
        </Table.Summary.Cell>
        <Table.Summary.Cell index={6}>
        </Table.Summary.Cell>
        <Table.Summary.Cell index={7}>
          {toFloat(totalCredit) || 0}/{toFloat(totalTotal_hours) || 0}
        </Table.Summary.Cell>
        <Table.Summary.Cell index={8}>
          {toFloat(totalCredit * 24) || 0}/{toFloat(totalTotal_hours) || 0}
        </Table.Summary.Cell>
        <Table.Summary.Cell index={9}>
          {totalTheoretical_training}
        </Table.Summary.Cell>
        <Table.Summary.Cell index={10}>
          {totalLab_pract_work}
        </Table.Summary.Cell>
        <Table.Summary.Cell index={11}>
          {totalCourse_projects}
        </Table.Summary.Cell>
        <Table.Summary.Cell index={12}>
          {totalSrs}
        </Table.Summary.Cell>
        <Table.Summary.Cell index={13}>
          {totalSrsp}
        </Table.Summary.Cell>
        <Table.Summary.Cell index={14}>
          {totalIndustrial_training}
        </Table.Summary.Cell>
        <Table.Summary.Cell index={15}>
          {totalProfessional_training}
        </Table.Summary.Cell>
        <Table.Summary.Cell index={16}>
          {totalIndividual}
        </Table.Summary.Cell>
        <Table.Summary.Cell index={17}>
          {totalSem_1}
        </Table.Summary.Cell>
        <Table.Summary.Cell index={18}>
          {totalSem_2}
        </Table.Summary.Cell>
        <Table.Summary.Cell index={19}>
          {totalSem_3}
        </Table.Summary.Cell>
        <Table.Summary.Cell index={20}>
          {totalSem_4}
        </Table.Summary.Cell>
        <Table.Summary.Cell index={21}>
          {totalSem_5}
        </Table.Summary.Cell>
        <Table.Summary.Cell index={22}>
          {totalSem_6}
        </Table.Summary.Cell>
        <Table.Summary.Cell index={23}>
          {totalSem_7}
        </Table.Summary.Cell>
        <Table.Summary.Cell index={24}>
          {totalSem_8}
        </Table.Summary.Cell>
      </Table.Summary.Row>
    )
  }, [currentDataTable])

  const columnActionRender = useCallback((text: any, record: any, index: any) => {
    const textEdit = (text: any) => {
      return (<div>
        <span>Вы подтверждаете действие  <br/>"{text}"</span>
      </div>)
    }

    switch (record.row_type) {
      case ROW_TYPE.qualification:
        return (
          !isEditedRup &&
          <Popover placement='topLeft' content={
            <Row style={{width: 300}} gutter={[16, 16]}>
              <Col span={24}>
                <Popconfirm placement="topLeft" title={textEdit(t('button.addGroupModule'))}
                            onConfirm={() => handleAddRow(record, index)} okText="Да" cancelText="Нет">
                  <MyButton width='100%' disabled={currentRupTableState.loading}>{t('button.addGroupModule')}</MyButton>
                </Popconfirm>
              </Col>
            </Row>
          } trigger='click'>
            <div style={{width: '100%'}}>
              <MyButton icon={<MoreOutlined/>} type='text' style={{padding: 0}}/>
            </div>
          </Popover>
        )
      case ROW_TYPE.qualification_evelated:
        return (
          !isEditedRup &&
          <Popover placement='topLeft' content={
            <Row style={{width: 300}} gutter={[16, 16]}>
              <Col span={24}>
                <Popconfirm placement="topLeft" title={textEdit(t('button.addModule'))}
                            onConfirm={() => handleAddRow(record, index)} okText="Да" cancelText="Нет">
                  <MyButton width='100%' disabled={currentRupTableState.loading}>{t('button.addModule')}</MyButton>
                </Popconfirm>
              </Col>
            </Row>
          } trigger='click'>
            <div style={{width: '100%'}}>
              <MyButton icon={<MoreOutlined/>} type='text' style={{padding: 0}}/>
            </div>
          </Popover>
        )
      case ROW_TYPE.group:
        return (
          !isEditedRup &&
          <Popover placement='topLeft' content={
            <Row style={{width: 300}} gutter={[16, 16]}>
              <Col span={24}>
                <Popconfirm placement="topLeft" title={textEdit(t('button.addModule'))}
                            onConfirm={() => handleAddRow(record, index)} okText="Да" cancelText="Нет">
                  <MyButton width='100%' disabled={currentRupTableState.loading}>{t('button.addModule')}</MyButton>
                </Popconfirm>
              </Col>
              <Col span={24}>
                <Popconfirm placement="topLeft" title={textEdit(t('button.deleteGroupModule'))}
                            onConfirm={() => handleDeleteRow(record, index)} okText="Да" cancelText="Нет">
                  <MyButton width='100%'
                            disabled={currentRupTableState.loading}>{t('button.deleteGroupModule')}</MyButton>
                </Popconfirm>
              </Col>
            </Row>
          } trigger='click'>
            <MyButton disabled={currentRupTableState.loading} icon={<MoreOutlined/>} type='text'
                      style={{padding: 0}}/>
          </Popover>
        )
      case ROW_TYPE.module_evelated:
        return (
          !isEditedRup &&
          <Popover placement='topLeft' content={
            <Row style={{width: 300}} gutter={[16, 16]}>
              <Col span={24}>
                <Popconfirm placement="topLeft" title={textEdit(t('button.addDiscipline'))}
                            onConfirm={() => handleAddRow(record, index)} okText="Да" cancelText="Нет">
                  <MyButton width='100%' disabled={currentRupTableState.loading}>{t('button.addDiscipline')}</MyButton>
                </Popconfirm>
              </Col>
              <Col span={24}>
                <Popconfirm placement="topLeft" title={textEdit(t('button.deleteModule'))}
                            onConfirm={() => handleDeleteRow(record, index)} okText="Да" cancelText="Нет">
                  <MyButton width='100%' disabled={currentRupTableState.loading}>{t('button.deleteModule')}</MyButton>
                </Popconfirm>
              </Col>
            </Row>
          } trigger='click'>
            <div style={{width: '100%'}}>
              <MyButton disabled={currentRupTableState.loading} icon={<MoreOutlined/>} type='text'
                        style={{padding: 0}}/>
            </div>
          </Popover>
        )
      case ROW_TYPE.module:
        return (
          !isEditedRup &&
          <Popover placement='topLeft' content={
            <Row style={{width: 300}} gutter={[16, 16]}>
              <Col span={24}>
                <Popconfirm placement="topLeft" title={textEdit(t('button.addRo'))}
                            onConfirm={() => handleAddRow(record, index)} okText="Да" cancelText="Нет">
                  <MyButton width='100%' disabled={currentRupTableState.loading}>{t('button.addRo')}</MyButton>
                </Popconfirm>
              </Col>
              <Col span={24}>
                <Popconfirm placement="topLeft" title={textEdit(t('button.addDiscipline'))}
                            onConfirm={() => handleAddRowDiscipline(record, index)} okText="Да" cancelText="Нет">
                  <MyButton width='100%' disabled={currentRupTableState.loading}>{t('button.addDiscipline')}</MyButton>
                </Popconfirm>
              </Col>
              <Col span={24}>
                <Popconfirm placement="topLeft" title={textEdit(t('button.deleteModule'))}
                            onConfirm={() => handleDeleteRow(record, index)} okText="Да" cancelText="Нет">
                  <MyButton width='100%' disabled={currentRupTableState.loading}>{t('button.deleteModule')}</MyButton>
                </Popconfirm>
              </Col>
            </Row>
          } trigger='click'>
            <div style={{width: '100%'}}>
              <MyButton disabled={currentRupTableState.loading} icon={<MoreOutlined/>} type='text'
                        style={{padding: 0}}/>
            </div>
          </Popover>
        )
      case ROW_TYPE.ro:
        return (
          !isEditedRup &&
          <Popover placement='topLeft' content={
            <Row style={{width: 300}} gutter={[16, 16]}>
              <Col span={24}>
                <Popconfirm placement="topLeft" title={textEdit(t('button.addDiscipline'))}
                            onConfirm={() => handleAddRow(record, index)} okText="Да" cancelText="Нет">
                  <MyButton width='100%' disabled={currentRupTableState.loading}>{t('button.addDiscipline')}</MyButton>
                </Popconfirm>
              </Col>
              <Col span={24}>
                <Popconfirm placement="topLeft" title={textEdit(t('button.deleteRo'))}
                            onConfirm={() => handleDeleteRow(record, index)} okText="Да" cancelText="Нет">
                  <MyButton width='100%' disabled={currentRupTableState.loading}>{t('button.deleteRo')}</MyButton>
                </Popconfirm>
              </Col>
            </Row>
          } trigger='click'>
            <div style={{width: '100%'}}>
              <MyButton disabled={currentRupTableState.loading} icon={<MoreOutlined/>} type='text'
                        style={{padding: 0}}/>
            </div>
          </Popover>
        )
      case ROW_TYPE.discipline_evelated:
        return (
          !isEditedRup &&
          <Popover placement='topLeft' content={
            <Row style={{width: 300}} gutter={[16, 16]}>
              <Col span={24}>
                <Popconfirm placement="topLeft" title={textEdit(t('button.addDiscipline'))}
                            onConfirm={() => handleAddRow(record, index)} okText="Да" cancelText="Нет">
                  <MyButton width='100%' disabled={currentRupTableState.loading}>{t('button.addDiscipline')}</MyButton>
                </Popconfirm>
              </Col>
              <Col span={24}>
                <Popconfirm placement="topLeft" title={textEdit(t('button.deleteDiscipline'))}
                            onConfirm={() => handleDeleteRow(record, index)} okText="Да" cancelText="Нет">
                  <MyButton width='100%' disabled={currentRupTableState.loading}>{t('button.deleteDiscipline')}</MyButton>
                </Popconfirm>
              </Col>
            </Row>
          } trigger='click'>
            <div style={{width: '100%'}}>
              <MyButton icon={<MoreOutlined/>} type='text' style={{padding: 0}}/>
            </div>
          </Popover>
        )
      case ROW_TYPE.row_from_tup:
        return (
          !isEditedRup &&
          <Popover placement='topLeft' content={
            <Row style={{width: 300}} gutter={[16, 16]}>
              <Col span={24}>
                <Popconfirm placement="topLeft" title={textEdit(t('button.deleteTupa'))}
                            onConfirm={() => handleDeleteRow(record, index)} okText="Да" cancelText="Нет">
                  <MyButton width='100%' disabled={currentRupTableState.loading}>{t('button.deleteTupa')}</MyButton>
                </Popconfirm>
              </Col>
            </Row>
          } trigger='click'>
            <div style={{width: '100%'}}>
              <MyButton disabled={currentRupTableState.loading} icon={<MoreOutlined/>} type='text'
                        style={{padding: 0}}/>
            </div>
          </Popover>
        )
      case ROW_TYPE.discipline:
      case ROW_TYPE.discipline_from_module:
        return (
          !isEditedRup &&
          <Popover placement='topLeft' content={
            <Row style={{width: 300}} gutter={[16, 16]}>
              <Col span={24}>
                <Popconfirm placement="topLeft" title={textEdit(t('button.deleteDiscipline'))}
                            onConfirm={() => handleDeleteRow(record, index)} okText="Да" cancelText="Нет">
                  <MyButton width='100%' disabled={currentRupTableState.loading}>{t('button.deleteDiscipline')}</MyButton>
                </Popconfirm>
              </Col>
            </Row>
          } trigger='click'>
            <div style={{width: '100%'}}>
              <MyButton disabled={currentRupTableState.loading} icon={<MoreOutlined/>} type='text'
                        style={{padding: 0}}/>
            </div>
          </Popover>
        )
      case ROW_TYPE.qualification_total:
      case ROW_TYPE.qualification_evelated_total:
        return false

      default:
        return
    }
  }, [currentDataTable, currentRupTableState, isEditedRup])

  const columnNameRender = useCallback((text: any, record: any, index: any, key: any) => {
    switch (record.row_type) {
      case ROW_TYPE.qualification:
      case ROW_TYPE.qualification_evelated:
        return (
          <MyText weight={700} size={16}>{text}</MyText>
        )
      case ROW_TYPE.discipline:
      case ROW_TYPE.discipline_evelated:
      case ROW_TYPE.discipline_from_module:
        return (
          <>
          <Select showSearch
                  placeholder={t('select.discipline.placeholder')}
                  style={{width: '100%'}}
                  filterOption={(input: any, option: any) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                  value={text}
                  loading={rupsDisciplinesState.loading}
                  onChange={(value: any, option: any) => handleChange(option.item, ROW_FIELD.discipline_id, record, index)}
                  disabled={!isEditedRup}
          >
            {rupsDisciplinesState.data?.map((discipline: any) => (
              <Select.Option key={discipline.id} value={discipline.id} item={{
                id: discipline.id,
                caption: discipline.caption
              }}>{discipline.caption}</Select.Option>
            ))}
          </Select>
          </>
        )
      case ROW_TYPE.group:
        return (
          <Input
            style={{fontWeight: '700'}}
            id={key + index}
            // defaultValue={text}
            value={text}
            onChange={(e) => handleChange(e.target.value, key, record, index)}
            disabled={!isEditedRup}
          />
        )

      case ROW_TYPE.qualification_total:
      case ROW_TYPE.qualification_evelated_total:
        return (
          <span style={{display: 'block', textAlign: 'center'}}>{t('select.total.placeholder')}</span>
        )
      default:
        return (
          <Input
            id={key + index}
            // defaultValue={text}
            value={text}
            onChange={(e) => handleChange(e.target.value, key, record, index)}
            disabled={!isEditedRup}
          />
        )
    }
  }, [currentDataTable, rupsDisciplinesState, isEditedRup])

  const columnFormControlRender = useCallback((text: any, record: any, index: any, key: any) => {
    switch (record.row_type) {
      case ROW_TYPE.qualification:
      case ROW_TYPE.qualification_evelated:
        return
      case ROW_TYPE.qualification_total:
      case ROW_TYPE.qualification_evelated_total:
        return text
      case ROW_TYPE.row_from_tup:
        return (
          <Input
            type="number"
            id={key + index}
            // defaultValue={text}
            min={0}
            onKeyPress={(e) => handleKeyPress(e)}
            onKeyDown={(e) => handleKeyDown(e)}
            value={text}
            onChange={(e) => handleChange(e.target.value, key, record, index)}
            onPressEnter={(e) => handleEnter(e)}
            ref={handleSetRefs}
            disabled={!isEditedRup}
          />
        )
      default :
        let strToArr = !text ? null : text.split(",");

        return (
          <Select
            id={key + index}
            mode='multiple'
            style={{width: '100%'}}
            // defaultValue={!strToArr ? [] : strToArr}
            value={!strToArr ? [] : strToArr}
            maxTagCount='responsive'
            onChange={(value) => handleChange(value, key, record, index)}
            disabled={!isEditedRup}
          >
            {
              [1, 2, 3, 4, 5, 6, 7, 8].map((num: number) => (
                <Select.Option key={num} value={String(num)}>{num}</Select.Option>
              ))
            }
            <Select.Option value='+'>+</Select.Option>
          </Select>
        )
    }
  }, [currentDataTable, isEditedRup])

  const columnStudyTimeCreditRender = useCallback((text: any, record: any, index: any, key: any) => {
    switch (record.row_type) {
      case ROW_TYPE.qualification:
      case ROW_TYPE.qualification_evelated:
        return
      case ROW_TYPE.qualification_total:
      case ROW_TYPE.qualification_evelated_total:
      case ROW_TYPE.group:
      case ROW_TYPE.module:
      case ROW_TYPE.module_evelated:
        return (
          <span style={{display: 'block', textAlign: 'center'}} className={cn(textDangerClass(record))}>
            {!text ? '' : toFloat(text)}
          </span>
        )
      default :
        return (
          <Input
            // defaultValue={!text ? '' : text}
            value={!text ? '' : text}
            id={key + index}
            type="number"
            min={0}
            className={cn(textDangerClass(record))}
            onKeyPress={(e) => handleKeyPress(e)}
            onKeyDown={(e) => handleKeyDown(e)}
            onChange={(e) => handleChange(Number(e.target.value), key, record, index)}
            onPressEnter={(e) => handleEnter(e)}
            ref={handleSetRefs}
            disabled={!isEditedRup}
          />
        )
    }
  }, [currentDataTable, isEditedRup])

  const columnStudyTimeTotalHoursRender = useCallback((text: any, record: any, index: any, key: any) => {
    switch (record.row_type) {
      case ROW_TYPE.qualification:
      case ROW_TYPE.qualification_evelated:
        return
      case ROW_TYPE.row_from_tup:
        return (
          <span style={{display: 'block', textAlign: 'center'}}>{record.credit * 24}</span>
        )
      default:
        let currentNumber = (toFloat(record.theoretical_training) + toFloat(record.lab_pract_work) + toFloat(record.course_projects) + toFloat(record.industrial_training) + toFloat(record.professional_training) + toFloat(record.individual) + toFloat(record.srsp))

        let credit = Math.ceil(record.credit * 24)
        return (
          <span style={{display: 'block', textAlign: 'center'}} className={cn(textDangerClass(record))}>
             {credit || 0}/{currentNumber || 0}
          </span>
        )
    }
  }, [currentDataTable, isEditedRup])

  const columnTotalHoursOfThemRender = useCallback((text: any, record: any, index: any, key: any) => {
    switch (record.row_type) {
      case ROW_TYPE.qualification:
      case ROW_TYPE.qualification_evelated:
        return
      case ROW_TYPE.qualification_total:
      case ROW_TYPE.qualification_evelated_total:
      case ROW_TYPE.group:
      case ROW_TYPE.module:
      case ROW_TYPE.module_evelated:
        return (
          <span style={{display: 'block', textAlign: 'center'}} className={cn(textDangerClass(record))}>
            {!text ? '' : text}
          </span>
        )
      default:
        return (
          <Input
            // defaultValue={!text ? '' : text}
            value={!text ? '' : text}
            className={cn(textDangerClass(record))}
            id={key + index}
            onChange={(e) => handleChange(Number(e.target.value), key, record, index)}
            onPressEnter={(e) => handleEnter(e)}
            type="number"
            min={0}
            onKeyPress={(e) => handleKeyPress(e)}
            onKeyDown={(e) => handleKeyDown(e)}
            ref={handleSetRefs}
            disabled={!isEditedRup}
          />
        )
    }
  }, [currentDataTable, isEditedRup])

  const columnHoursBySemesterRender = useCallback((text: any, record: any, index: any, key: any) => {
    switch (record.row_type) {
      case ROW_TYPE.qualification:
      case ROW_TYPE.qualification_evelated:
        return
      case ROW_TYPE.qualification_total:
      case ROW_TYPE.qualification_evelated_total:
      case ROW_TYPE.module:
      case ROW_TYPE.group:
      case ROW_TYPE.module_evelated:
        return (
          <span style={{display: 'block', textAlign: 'center'}} className={cn(textDangerClass(record))}>
            {!text ? '' : text}
          </span>
        )
      default:
        return (
          <Input
            // defaultValue={!text ? '' : text}
            value={!text ? '' : text}
            id={key + index}
            className={cn(textDangerClass(record))}
            onChange={(e) => handleChange(Number(e.target.value), key, record, index)}
            onPressEnter={(e) => handleEnter(e)}
            type="number"
            min={0}
            onKeyPress={(e) => handleKeyPress(e)}
            onKeyDown={(e) => handleKeyDown(e)}
            ref={handleSetRefs}
            disabled={!isEditedRup}
          />
        )

    }
  }, [currentDataTable, isEditedRup])

  const innerTabs = [
    {
      key: '1',
      label: t('tabs.rup'),
      children: (
        <Row gutter={[16, 32]} style={{padding: '0 8px'}}>
          <Col span={24} style={{backgroundColor: 'rgba(80,184,95,.2)'}}>
            <Row style={{padding: 18}}>
              <Col span={8}>
                <Row>
                  <Col span={24}>
                    <MyText>
                      {t('rupName')}:
                    </MyText>
                    <MyText>
                      {currentRupState?.data?.name}
                    </MyText>
                  </Col>

                  <Col span={24}>
                    <MyText>
                      {t('studentBase')}:
                    </MyText>
                    <MyText>
                      {RUP_BASE_TYPES().find(rupType => rupType.id === currentRupState?.data?.type)?.caption}
                    </MyText>
                  </Col>

                  {
                    currentRupState?.data?.linkGroups?.length > 0 &&
                    <Col span={24}>
                      <MyText>
                        {t('groups')}:
                      </MyText>
                      <MyText>
                        {currentRupState?.data?.linkGroups?.map((item: any) => item?.group?.caption)}
                      </MyText>
                    </Col>
                  }

                </Row>
              </Col>

              <Col span={8}>
                <Row>
                  <Col span={24}>
                    <MyText>
                      {t('table.profile')}:
                    </MyText>
                    <MyText>
                      {currentRupState?.data?.profile?.caption} - {currentRupState?.data?.profile?.code}
                    </MyText>
                  </Col>

                  <Col span={24}>
                    <MyText>
                      {t('table.profileRoute')}:
                    </MyText>
                    <MyText>
                      {currentRupState?.data?.profile_direction?.caption} - {currentRupState?.data?.profile_direction?.code}
                    </MyText>
                  </Col>
                </Row>
              </Col>

              <Col span={8}>
                <Row>
                  <Col span={24}>
                    <MyText>
                      {t('table.specialization')}:
                    </MyText>
                    <MyText>
                      {currentRupState?.data?.specialization?.caption} - {currentRupState?.data?.specialization?.code}
                    </MyText>
                  </Col>

                  <Col span={24}>
                    <MyText>
                      {t('table.specialty')}:
                    </MyText>
                    <MyText>
                      {currentRupState?.data?.speciality?.caption} - {currentRupState?.data?.speciality?.code}
                    </MyText>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>

          <Col span={24}>
            <Row gutter={[16, 16]}>
              <Col span={24}>
                <Row gutter={[16, 8]}>
                  {tableLegend.map((legend: any) => (
                    <Col key={legend.color}>
                      <Badge styles={{
                        indicator: {
                          width: 16,
                          height: 16
                        }
                      }} color={legend.color} text={legend.label}/>
                    </Col>
                  ))}
                </Row>
              </Col>

              <Col span={24}>
                <Row justify='space-between'>
                  <Col>
                    <Row gutter={[16, 16]}>
                      <Col>
                        <MyButton onClick={handleExport}
                                  disabled={currentRupTableState.loading}>{t('button.exportExcel')}</MyButton>
                      </Col>
                      <Col>
                        <MyButton onClick={() => {
                          if(isEditedRup) {
                            handleModal(() => onSuccessHandler(() => window.open(location.pathname, '_blank')), () => onFailedHandler(() => window.open(location.pathname, '_blank')))
                          } else {
                            window.open(location.pathname, '_blank')
                          }
                        }}>
                          Открыть на весь экран
                        </MyButton>
                      </Col>
                    </Row>
                  </Col>

                  <Col>
                    {
                      isEditedRup ?
                        <MyButton onClick={handleSave}
                                  disabled={currentRupTableState.loading}>{t('button.save')}</MyButton>
                        :
                        <MyButton onClick={handleEdit}
                                  disabled={currentRupTableState.loading}>{t('button.edit')}</MyButton>
                    }
                  </Col>
                </Row>
              </Col>

              <Col>
                <StyledRupTable pagination={false}
                                scroll={{y: 560, x: 1600}}
                                bordered
                                loading={currentRupTableState.loading}
                  // @ts-ignore
                                columns={columns}
                                dataSource={currentDataTable}
                                rowClassName={(record) => rowClassName(record)}
                                summary={pageData => summary(pageData)}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      )
    },
    {
      key: '2',
      label: t('select.weekSettings.label'),
      children: (
        <Card bordered={false} loading={semesterSettingsState.loading}>
          <Row gutter={[16, 16]} align='middle'>
            <Col span={24}>
              <MyText weight={700} size={24}>
                {t('select.weekSettings.label')}
              </MyText>
            </Col>
            {
              settingArr.map((setting: any) => (
                <Col span={24} key={setting.func}>
                  <Row align='middle'>
                    <Col span={12}>
                      <MyText>{setting.label} {t('semester')} </MyText>
                    </Col>
                    <Col span={12}>
                      <Input onChange={(e) => handleChangeSemesterSetting(setting.func, e.target.value)}
                             disabled={isSettingDisable}
                        // @ts-ignore
                             value={settingState[setting?.value]} placeholder={setting.placeholder} type='number'/>
                    </Col>
                  </Row>
                </Col>
              ))
            }

            <Col span={24}>
              <Row gutter={16}>
                {
                  !isSettingDisable ?
                    <Col>
                      <Row gutter={16}>
                        <Col>
                          <MyButton onClick={() => {
                            setIsSettingDisable(true)
                            setSettingState({...semesterSettingsState.data, rup_id: rupId})
                          }}>{t('button.cancel')}</MyButton>
                        </Col>
                        <Col>
                          <MyButton onClick={() => handleSemesterSetting()}>{t('button.save')}</MyButton>
                        </Col>
                      </Row>
                    </Col>
                    :
                    <Col>
                      <MyButton onClick={() => setIsSettingDisable(false)}>{t('button.edit')}</MyButton>
                    </Col>
                }
              </Row>
            </Col>
          </Row>
        </Card>
      )
    },
    {
      key: '3',
      label: t('translate'),
      children: (
        <Table columns={columnRupTranslate} dataSource={translateArr}
               pagination={false} bordered loading={rupTranslateState.loading}
               rowKey={(record: any) => record.id}/>
      )
    }
  ]

  return (
    <Card loading={currentRupState.loading}>
      <InnerTabs items={innerTabs} onChange={(value) => handleChangeTab(value)}
                 tabBarExtraContent={(
                   <Row gutter={16}>
                     <Col>
                       <MyButton onClick={() => handleBackToAllRups()} warning>{t('button.backToAllRup')}</MyButton>
                     </Col>
                     <Col>
                       <MyButton onClick={() => handleBackToQualifications()} info>{t('button.backQualification')}</MyButton>
                     </Col>
                   </Row>
                 )} activeKey={currentTab}/>
    </Card>
  );
}
